export const LABELS = {
  NEW_CONTACTS: 'promote-contacts-new',
  NEW_SUBSCRIBERS: 'contacts-subscribed',
  NEW_CONTACT_FORM_SUBMISSIONS: 'contacts-contacted_me',
  NEW_CUSTOMERS: 'contacts-customers',
};
